import { getPartnerFilesById } from 'legacy/lut/features/partner/api'
import { selectPartnerFiles } from 'legacy/lut/features/partner/selectors'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'

export const useGetPartnerFiles = (partnerId: string, options?: ICrudFetchOptions) => {
  const dispatch = useAppDispatch()
  const { data, status, message } = useSelector(selectPartnerFiles, shallowEqual)

  useEffect(() => {
    dispatch(getPartnerFilesById({ partnerId, options }))
  }, [partnerId, dispatch, options])

  return { partnerFiles: data, status, message }
}
